module.exports = __webpack_public_path__ + "img/manager-icon.238471f5.svg";